"use client";

import { useEffect } from "react";
import { useUser } from "@auth0/nextjs-auth0/client";
import { initDatadogRum, datadogRum } from "@/lib/datadog-rum";

function isMonitoringAllowed(): boolean {
  if (typeof document === "undefined") return false;
  try {
    const consent = document.cookie
      .split("; ")
      .find((row) => row.startsWith("cookie-consent="))
      ?.split("=")[1];
    return consent === "accepted";
  } catch {
    return false;
  }
}

export function DatadogUserProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useUser();

  useEffect(() => {
    function tryIdentify() {
      if (!isMonitoringAllowed()) {
        datadogRum.clearUser();
        return;
      }
      // Initialize RUM only after consent is confirmed
      initDatadogRum();
      if (user) {
        datadogRum.setUser({
          id: user.sub ?? undefined,
          email: user.email ?? undefined,
        });
      } else {
        datadogRum.clearUser();
      }
    }

    tryIdentify();
    const handler = () => tryIdentify();
    window.addEventListener("cookie-consent-change", handler);
    return () => window.removeEventListener("cookie-consent-change", handler);
  }, [user]);

  return <>{children}</>;
}
